"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var tiptapExtensions_exports = {};
__export(tiptapExtensions_exports, {
  Blockquote: () => import_extension_blockquote.Blockquote,
  Bold: () => import_extension_bold.Bold,
  BulletList: () => import_extension_bullet_list.BulletList,
  Document: () => import_extension_document.Document,
  Dropcursor: () => import_extension_dropcursor.Dropcursor,
  Gapcursor: () => import_extension_gapcursor.Gapcursor,
  HardBreak: () => import_extension_hard_break.HardBreak,
  Heading: () => import_extension_heading.Heading,
  History: () => import_extension_history.History,
  HorizontalRule: () => import_extension_horizontal_rule.HorizontalRule,
  Italic: () => import_extension_italic.Italic,
  Link: () => import_extension_link.Link,
  ListItem: () => import_extension_list_item.ListItem,
  OrderedList: () => import_extension_ordered_list.OrderedList,
  Paragraph: () => import_extension_paragraph.Paragraph,
  Strike: () => import_extension_strike.Strike,
  Table: () => import_extension_table.Table,
  TableCell: () => import_extension_table_cell.TableCell,
  TableHeader: () => import_extension_table_header.TableHeader,
  TableRow: () => import_extension_table_row.TableRow,
  TaskItem: () => import_extension_task_item.TaskItem,
  TaskList: () => import_extension_task_list.TaskList,
  Text: () => import_extension_text.Text,
  TextAlign: () => import_extension_text_align.TextAlign,
  TextStyle: () => import_extension_text_style.TextStyle,
  Typography: () => import_extension_typography.Typography,
  Underline: () => import_extension_underline.Underline
});
module.exports = __toCommonJS(tiptapExtensions_exports);
var import_extension_text_style = require("@tiptap/extension-text-style");
var import_extension_blockquote = require("@tiptap/extension-blockquote");
var import_extension_bold = require("@tiptap/extension-bold");
var import_extension_document = require("@tiptap/extension-document");
var import_extension_dropcursor = require("@tiptap/extension-dropcursor");
var import_extension_gapcursor = require("@tiptap/extension-gapcursor");
var import_extension_hard_break = require("@tiptap/extension-hard-break");
var import_extension_heading = require("@tiptap/extension-heading");
var import_extension_history = require("@tiptap/extension-history");
var import_extension_horizontal_rule = require("@tiptap/extension-horizontal-rule");
var import_extension_italic = require("@tiptap/extension-italic");
var import_extension_paragraph = require("@tiptap/extension-paragraph");
var import_extension_strike = require("@tiptap/extension-strike");
var import_extension_text = require("@tiptap/extension-text");
var import_extension_link = require("@tiptap/extension-link");
var import_extension_typography = require("@tiptap/extension-typography");
var import_extension_underline = require("@tiptap/extension-underline");
var import_extension_bullet_list = require("@tiptap/extension-bullet-list");
var import_extension_list_item = require("@tiptap/extension-list-item");
var import_extension_ordered_list = require("@tiptap/extension-ordered-list");
var import_extension_text_align = require("@tiptap/extension-text-align");
var import_extension_task_list = require("@tiptap/extension-task-list");
var import_extension_table = require("@tiptap/extension-table");
var import_extension_table_cell = require("@tiptap/extension-table-cell");
var import_extension_table_header = require("@tiptap/extension-table-header");
var import_extension_table_row = require("@tiptap/extension-table-row");
var import_extension_task_item = require("@tiptap/extension-task-item");
//# sourceMappingURL=tiptapExtensions.js.map
